var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21408 14.9075C2.76063 14.9075 2.37259 14.7462 2.04995 14.4236C1.72732 14.1009 1.56572 13.7126 1.56517 13.2586V2.54074H0.740723V0.891835H4.86298V0.0673828H9.80969V0.891835H13.932V2.54074H13.1075V13.2586C13.1075 13.7121 12.9462 14.1004 12.6235 14.4236C12.3009 14.7467 11.9126 14.9081 11.4586 14.9075H3.21408ZM11.4586 2.54074H3.21408V13.2586H11.4586V2.54074ZM4.86298 11.6097H6.51188V4.18964H4.86298V11.6097ZM8.16079 11.6097H9.80969V4.18964H8.16079V11.6097Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconSa);
export default __webpack_public_path__ + "static/media/deleteIconSA.18dc46b65b9732a97c5d3c3f676cbc88.svg";
export { ForwardRef as ReactComponent };